<div class="qr-scan-dialog">
  <h2 class="qr-scan-dialog__title">Scan Customer QR Code</h2>
  <p class="qr-scan-dialog__help" data-testid="qr-scan-help">
    Hold the customer's QR code from the Chick-fil-A One app in front of the camera. The search runs automatically once the code is recognized.
  </p>
  @if (errorText) {
    <div class="qr-scan-dialog__error" data-testid="qr-scan-error">{{errorText}}</div>
  }
  <video #video class="qr-scan-dialog__video" [class.qr-scan-dialog__video-hidden]="!isCameraReady"
         [hidden]="errorText" muted playsinline></video>
  <div class="qr-scan-dialog__actions">
    <button mat-button type="button" data-testid="qr-scan-cancel" (click)="dialogRef.close()">Cancel</button>
  </div>
</div>
